import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateActivityCategoryPipe } from './translate-activity-category.pipe';

@NgModule({
  imports: [CommonModule, TranslateActivityCategoryPipe],
  exports: [TranslateActivityCategoryPipe],
})
export class TranslateActivityCategoryPipeModule {}
